module.exports = "/_next/static/images/replace-card-c782b47f7c22d4a5775912dcf177cf2d.svg";